import React from 'react'
import PropTypes from 'prop-types'
import PageTitle from '../features/ui/util/page_title'
import WrappedBundle from '../features/ui/util/wrapped_bundle'
import DefaultLayout from '../layouts/default_layout'
import { GabAdTopPanel } from '../features/ui/util/async_components'
import List from '../components/list'
import { SUGGESTION_TYPE_FEEDS, SUGGESTION_TYPE_GROUPS, SUGGESTION_TYPE_RELATED } from '../constants'
import ResponsiveClassesComponent from '../features/ui/util/responsive_classes_component'

function SuggestionsSidebar() {
  const items = [
    {
      title: 'Popular Accounts',
      to: '/suggestions',
    },
    {
      title: 'Related Accounts',
      to: `/suggestions?view=${SUGGESTION_TYPE_RELATED}`,
    },
    {
      title: 'Groups',
      to: `/suggestions?view=${SUGGESTION_TYPE_GROUPS}`,
    },
    {
      title: 'Feeds',
      to: `/suggestions?view=${SUGGESTION_TYPE_FEEDS}`,
    }
  ]
  return (
    <div className={[_s.d, _s.w100PC, _s.boxShadowNone].join(' ')}>
      <List items={items} />
    </div>
  )
}

class SuggestionsPage extends React.PureComponent {

  render() {
    const { children } = this.props

    const title = 'Suggestions'

    const sidebarChildren = [
      <SuggestionsSidebar noPanel />,
      <WrappedBundle key='suggestions-page-ad-panel' component={GabAdTopPanel} componentParams={{ noPanel: true, pageKey: 'suggestions.sidebar', position: 1 }} />,
    ]

    return (
      <DefaultLayout
        noComposeButton
        showBackBtn
        noRightSidebar
        title={title}
        page='suggestions'
        sidebarChildren={sidebarChildren}
      >
        <PageTitle path={title} />
        <ResponsiveClassesComponent
          classNames={[_s.d, _s.w100PC, _s.px15, _s.mlAuto, _s.mrAuto, _s.jcCenter].join(' ')}
          classNamesXS={[_s.d, _s.w100PC, _s.jcCenter].join(' ')}
        >
          {children}
        </ResponsiveClassesComponent>
      </DefaultLayout>
    )
  }

}

SuggestionsPage.propTypes = {
  children: PropTypes.node.isRequired,
}

export default SuggestionsPage
